//preload
import {preload} from "../include/module";
preload();

//checkSP
import {checkSP} from "../include/module";
checkSP();

//anchorLink
// import {anchorLink} from "../include/module";
// anchorLink();

//resizeHeader
import {resizeHeader} from "../include/module";
resizeHeader();

//toggleMenu
import {toggleMenu} from "../include/module";
toggleMenu();

//  paraBg
import {paraBg} from "../include/module";
paraBg();


// ------------------------------------------------------------------------
// swiper
// ------------------------------------------------------------------------
const chara_swiper = () => {
  const charaThumbnail = new Swiper('.chara-Thumbnail', {
    slidesPerView: 5,
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });
  const swiper = new Swiper('.chara-Content', {
    // Optional parameters
    hashNavigation: {
      replaceState: true,
    },
    loop: false,
    allowTouchMove: false,
    slidesPerView: 1,
    speed: 500,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    on: {
      slideChange: function () {
        swiperScroll();
      },
    },
    thumbs: {
      swiper: charaThumbnail
    },
  });
};
// $(window).on('load', function(){
//   setTimeout(function () {
//     chara_swiper();
//   }, 100);
// });




$(window).on('load', function(){
  setTimeout(function () {
    chara_swiper();
  }, 100);

  //ページ外から
  var urlHash = location.hash;
  if(urlHash) {
      setTimeout(function(){
          swiperScroll();
      }, 100);
  }
});

function swiperScroll() {

  var scrollSpeed;
  var scrollTarget   = $('#profile-List');
  var scrollAdjust   = 40;
  var scrollPosition = scrollTarget.offset().top;

  // if(!_isSP){
    scrollSpeed = 300;
  // }else{
    // scrollSpeed = 0;
  // }

  $("html, body").animate({scrollTop: scrollPosition - scrollAdjust}, scrollSpeed, "linear");
  return false;
};



// WEBPACK FOOTER //
// ./src/popipa-movie_v1/assets/js/character/script.js